module.exports = __webpack_public_path__ + "media/images/skebi/icon-sofa-f1e37d3aef4b01f854b05dde60762999.png";